import * as React from 'react';

import {FacetField, SearchResult} from '../search.types';
import {FacetLine} from '../browse-sidebar/FacetLine';
import {URLBuilder} from '../../../server/tools/url-builder/url-builder.class';
import {EmptyState} from '../../ui/EmptyState/EmptyState';

interface SelectorFacetsProps {
    buildURL: URLBuilder;
    resultList: SearchResult;
    selectorFacets?: FacetField[];
}

export const SelectorFacets = ({buildURL, resultList, selectorFacets}: SelectorFacetsProps) => {
    if (!(selectorFacets?.length > 0)) {
        return null;
    }
    return (
        <>
            <h5 className="tw-flex tw-justify-between tw-items-center tw-mb-3">
                Selection Guide
                {resultList.currentFilters.length > 0 && resultList.totalItems > 0 && (
                    <a
                        className="tw-text-base tw-font-normal tw-leading-[1.2] tw-mb-0"
                        href={buildURL.withNoFilters()}
                    >
                        Clear All Filters
                    </a>
                )}
            </h5>
            <div className="tw-flex tw-overflow-x-auto">
                {selectorFacets.map((selector, selectorIndex) => (
                    <div
                        className="tw-relative tw-flex tw-flex-col tw-border tw-bg-white tw-rounded-sm tw-mr-3 !tw-min-w-[300px]"
                        key={selectorIndex}
                    >
                        <div className="tw-py-3 tw-px-5 tw-mb-0 tw-bg-gray-100 tw-border-b tw-font-bold">{selector.name}</div>
                        <div className="tw-overflow-y-auto !tw-p-0 !tw-h-[290px]">
                            <ul className="tw-list-none tw-pl-0">
                                {selector.facets && selector.facets.length === 0 && (
                                    <EmptyState
                                        className="tw-px-4"
                                        message="No results found with current selected filters"
                                    />
                                )}
                                {selector.facets.map((facet, facetIndex) => (
                                    <FacetLine
                                        className="tw-py-3 tw-px-5 tw-border-b tw-text-sm"
                                        facet={facet}
                                        facetField={selector}
                                        facetIndex={facetIndex}
                                        key={facetIndex}
                                        urlBuilder={buildURL}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};
